{
  "accountScreen": {
    "downloadCta": "Telechaje dokiman ki siyen an",
    "helpDescription": "Voye yon imèl ba nou nan <underline>{{email}}</underline>",
    "helpTitle": "Ou bezwen èd oswa ou gen kesyon?",
    "loggedInWith": "Ou konekte avèk {{method}}",
    "title": "Kont",
    "usernameLoginMethod": "Non itilizatè"
  },
  "addHouseholdMemberScreen": {
    "addAnother": "Ajoute yon lòt moun",
    "addingMemberDescription": "Nou vle konnen tout moun ki abite lakay ou.",
    "addingMemberTitle": "Pale nou de yo",
    "age": "Laj",
    "coverageCheck": {
      "dateOfBirth": "Dat nesans (si ou vle)",
      "description": "Si ou vle. Sa ede nou jwenn asirans yo te ka deja genyen.",
      "medicaidId": "Nimewo Medicaid (si ou vle)",
      "medicaidIdPlaceholder": "Antre nimewo Medicaid la",
      "ssn": "Nimewo Sekirite Sosyal (si ou vle)",
      "ssnPlaceholder": "XXX-XX-XXXX",
      "title": "Ede nou verifye asirans yo"
    },
    "duplicateDialog": {
      "cancel": "Non, tounen",
      "checkError": "Nou pa t kapab verifye manm fanmi w yo. Tanpri reseye.",
      "confirm": "Wi, se yon lòt moun",
      "description": "Ou deja ajoute <bold>{{name}}</bold>. Èske moun w ap ajoute kounye a se yon lòt moun?",
      "descriptionWithDetails": "Ou deja ajoute <bold>{{name}}</bold> ({{details}}). Èske moun w ap ajoute kounye a se yon lòt moun?",
      "reminder": "Ou pa bezwen ajoute yon moun ou deja ajoute.",
      "title": "Èske se yon nouvo moun?"
    },
    "enterDateOfBirth": "Antre dat nesans la pito",
    "enterRelationship": "Ki rapò li gen avèk ou",
    "firstName": "Prenon",
    "formSubmission": {
      "error": "Nou pa t kapab ajoute moun sa a nan fanmi an. Tanpri reseye.",
      "success": "Nou ajoute {{firstName}} avèk siksè"
    },
    "lastName": "Non fanmi",
    "livingWithMe": "L ap viv avèk mwen",
    "relationshipToMe": "Rapò li gen avèk mwen",
    "sameMailingAddress": "Menm adrès postal",
    "updateFormSubmission": {
      "success": "Enfòmasyon {{firstName}} mete ajou avèk siksè"
    },
    "validations": {
      "ageOrDateOfBirthRequired": "Tanpri antre laj ou oswa dat nesans ou.",
      "futureDateOfBirth": "Tanpri antre yon dat nesans ki se jodi a oswa anvan jodi a.",
      "invalidDateOfBirth": "Tanpri antre yon dat nesans ki valab (mwa/jou/ane).",
      "selectAnOption": "Tanpri chwazi yon opsyon.",
      "specifyRelationship": "Tanpri di nou ki rapò moun sa a gen avè w."
    }
  },
  "appFooter": {
    "partnershipLabel": "An patenarya avèk"
  },
  "appHeader": {
    "toggleThemeTooltip": "Bouton tèm sa a se pou tès sèlman."
  },
  "appMenu": {
    "account": "Kont",
    "household": "Fanmi",
    "language": "Lang",
    "logout": "Dekonekte"
  },
  "applicantDocuments": {
    "alsoCompleted": "Dokiman sa a konplete {{section}} tou.",
    "alsoCompletedResidenceForMembers": "Dokiman sa a konplete {{section}} tou pou manm nan kay la ki rete nan menm adrès la",
    "deleteDialog": {
      "description": "Èske ou sèten ou vle efase dokiman sa a? Ou p ap ka rekipere li ankò.",
      "title": "Efase dokiman"
    },
    "deleteToast": {
      "error": "Nou pa t kapab efase dokiman sa a. Tanpri reseye.",
      "success": "Dokiman an efase avèk siksè"
    },
    "immigrationIncomplete": {
      "description": "Ou toujou bezwen voye yon ID USCIS, dokiman/apwobasyon imigrasyon, oswa yon I-20 pou w konplete {{section}}.",
      "dismiss": "Mwen konprann",
      "title": "Nou bezwen yon lòt dokiman"
    },
    "optional": "Opsyonèl",
    "progress": "{{completeCount}} sou {{applicableCount}} fini",
    "selectDocumentType": "Chwazi kalite dokiman an",
    "ssn": {
      "cardOption": "Oswa voye kat Sekirite Sosyal ou",
      "label": "Nimewo Sekirite Sosyal",
      "save": "Sove",
      "saveError": "Nou pa t kapab sove nimewo sa a. Tanpri reseye.",
      "saved": "Nimewo Sekirite Sosyal anrejistre"
    },
    "supportedFiles": "Kalite fichye nou aksepte: PDF, JPG, PNG",
    "upload": {
      "failed": "Nou pa t kapab voye dokiman sa a. Tanpri reseye.",
      "failedDescription": "Nou pa ka li fichye sa a. Tanpri wete l epi voye yon lòt.",
      "uploading": "L ap voye..."
    },
    "uploadOne": "Voye <bold>omwen youn:</bold>"
  },
  "applicationAddressScreen": {
    "description": "Tanpri verifye adrès kay ak adrès postal pou tout moun nan fanmi an.",
    "homeAddress": "Adrès kay",
    "isHomeless": "Pa gen adrès kay",
    "mailingAddress": "Adrès postal",
    "needsHomeAddress": "<italic>Bezwen adrès kay</italic>",
    "needsMailingAddress": "<italic>Bezwen adrès postal</italic>",
    "noMailingAddress": "Pa gen Adrès pou Resevwa Lèt",
    "sameHomeAddress": "Menm adrès kay",
    "sameMailingAddress": "Menm adrès postal",
    "title": "Enfòmasyon sou adrès",
    "updateHouseholdAddressesDialog": {
      "addressTypeHome": "adrès kay",
      "addressTypeHomeAndMailing": "adrès kay ak postal",
      "addressTypeMailing": "adrès postal",
      "description_one": "{{householdName}} ak {{count}} lòt pataje {{addressType}} ou kounye a. Èske ou vle mete ajou pa yo tou?",
      "description_other": "{{householdName}} ak {{count}} lòt pataje {{addressType}} ou kounye a. Èske ou vle mete ajou pa yo tou?",
      "description_zero": "{{householdName}} pataje {{addressType}} ou kounye a. Èske ou vle mete ajou pa yo tou?",
      "onlyUpdateMine": "Non, mete ajou pa mwen sèlman",
      "title": "Mete ajou adrès fanmi",
      "updateMembers_one": "Mete ajou {{count}} manm",
      "updateMembers_other": "Mete ajou {{count}} manm"
    },
    "you": "{{name}} (Ou menm)"
  },
  "applicationChildCaregiverStatusScreen": {
    "description": "Timoun yo dwe <bold>viv avèk moun sa a</bold> pandan <bold>plis pase mwatye ane a</bold> epi moun sa a dwe <bold>peye plis pase mwatye</bold> nan <bold>depans li yo</bold> (manje, kay, lekòl, ak bòdwo lopital). Sa gen ladan l timoun ki pa fanmi san.",
    "title": "Èske moun sa yo ap viv epi pran swen timoun ki gen mwens pase 19 ane?"
  },
  "applicationCitizenshipStatusScreen": {
    "description": "Èske <bold>{{householdMembersNames}}</bold> tout se sitwayen ameriken?",
    "hintDescription": "Si ou chwazi <bold>Non</bold>, pa bay kò ou pwoblèm. Gen lòt opsyon ki disponib selon estati imigrasyon ou.",
    "noDescription": "Gen kèk oswa yo tout ki pa sitwayen ameriken",
    "title": "Eligibilite pou aplikasyon an",
    "yesDescription": "Tout moun ki nan lis la se sitwayen ameriken"
  },
  "applicationConfirmationScreen": {
    "brokerDeclined": {
      "description": "Chwazi “Wi, konekte m” pou jwenn èd pou rete ak doktè w yo epi kouvri fanmi w nan yon sèl kote.",
      "summaryWithMedicaid": "N ap revize aplikasyon Medicaid ou a epi n ap kontakte w si nou bezwen anyen. W ap toujou bezwen yon ajan asirans ki gen lisans pou fini enskripsyon an nan {{programs}}.",
      "summaryWithoutMedicaid": "Nou gen sa w te voye a. W ap toujou bezwen yon ajan asirans ki gen lisans pou fini enskripsyon an nan {{programs}}.",
      "title": "Ou te chwazi pou w pa konekte ak yon ajan asirans ki gen lisans. Èske w sèten?"
    },
    "continueButton": "Kontinye",
    "description": "Ekip nou an ap revize aplikasyon ou yo epi n ap kontakte w si nou bezwen anyen. Lè tout bagay an lòd, n ap voye yo bay pwogram ou te chwazi yo.",
    "title": "Nou resevwa aplikasyon ou yo!"
  },
  "applicationCoverageStatusScreen": {
    "description": "Èske <bold>{{householdMembersNames}}</bold> gen asirans sante? Mete kouvèti ki pral kòmanse byento tou.",
    "noDescription": "Pèsonn pa gen asirans",
    "pleaseSpecify": "Tanpri bay detay",
    "title": "Estati asirans",
    "whatType": "Ki kalite asirans?",
    "who": "Kiyès ki gen asirans?",
    "yesDescription": "Gen yon moun ki gen asirans"
  },
  "applicationDateOfBirthScreen": {
    "description": "Tanpri ajoute epi konfime pou tout moun nan fanmi an",
    "success": "Tout dat nesans yo anrejistre",
    "title": "Dat nesans"
  },
  "applicationDocuments": {
    "description": "N ap sèvi ak dokiman sa yo pou nou verifye enfòmasyon nan aplikasyon w lan. Ou ka voye yo kounye a oswa tounen pi ta.",
    "title": "Voye dokiman yo"
  },
  "applicationExpensesScreen": {
    "addAnotherExpense": "Ajoute yon lòt depans",
    "addExpense": "Ajoute yon depans",
    "description": "Ajoute depans medikal pou chak moun nan fanmi an.",
    "expenseTypes": {
      "ALIMONY_PAID": "Pansyon alimantè ou peye",
      "CHILDCARE": "Gad timoun",
      "IRA_CONTRIBUTIONS": "Kontribisyon IRA",
      "MEDICAL_EXPENSES": "Depans medikal",
      "MOVING_EXPENSES": "Depans demenajman",
      "NONE": "Okenn",
      "OTHER": "Lòt",
      "STUDENT_LOANS": "Prè etidyan",
      "TUITION_FEES": "Frè lekòl"
    },
    "memberDialog": {
      "alertDescriptions": {
        "MEDICAL_EXPENSES": "N ap mande w pou voye prèv depans sa a pi ta, donk prepare dokiman w yo. Sa ka bòdwo lopital oswa resi famasi.",
        "OTHER": "N ap mande w pou voye prèv depans sa a pi ta.",
        "STUDENT_LOANS": "N ap mande w pou voye prèv depans sa a pi ta. Sa ka lèt prè etidyan oswa dokiman lekòl."
      },
      "medicalExpenses3MonthsHelpNeededStatus": "Èske ou gen depans medikal nan 3 dènye mwa yo ou bezwen èd pou peye?",
      "title": "Chwazi yon depans"
    },
    "monthlyExpense": "{{monthlyExpense}} / pa mwa",
    "progress": "Pwogrè: {{progress}} sou {{total}} fini",
    "title": "Depans fanmi an"
  },
  "applicationFlow": {
    "amountPerMonth": "Kantite kòb pa mwa"
  },
  "applicationForm": {
    "applyingToCounter": "N ap aplike nan {{programsCount}} pwogram pou {{householdMembersCount}} moun",
    "continueButton": "Kontinye nan aplikasyon yo",
    "greatNews": "Bon nouvèl!",
    "letsCreateApplications": "Ann prepare aplikasyon pou tout moun.",
    "mayBeEligible": "<bold>{{names}}</bold> ka elijib",
    "mayBeEligibleFor": "{{memberNames}} ka elijib pou <bold>{{brand}}</bold>",
    "notEligible": "Pa elijib pou kounye a",
    "programConflictDialog": {
      "description": "Aplike pou {{newProgram}} ap retire aplikasyon {{currentPrograms}} pou {{memberNames}}. {{memberNames}} pa ka aplike pou toude an menm tan. Lè ou soumèt, n ap asire {{memberNames}} nan bon pwogram nan.",
      "description_members": "Aplike pou {{newProgram}} ap retire aplikasyon {{currentPrograms}} yo pou {{memberNames}}. {{memberNames}} pa ka aplike pou toude an menm tan. Lè ou soumèt, n ap asire {{memberNames}} tout nan bon pwogram nan.",
      "description_self": "Aplike pou {{newProgram}} ap retire aplikasyon {{currentPrograms}} ou a. Ou pa ka aplike pou toude an menm tan. Lè ou soumèt, n ap asire w ou nan bon pwogram nan.",
      "keepButton": "Kenbe {{currentPrograms}}",
      "multipleDescription": "Aplike pou {{newProgram}} ap retire aplikasyon {{currentPrograms}} yo pou {{memberNames}}. {{memberNames}} pa ka aplike pou tout an menm tan. Lè ou soumèt, n ap asire {{memberNames}} nan bon pwogram nan.",
      "multipleDescription_members": "Aplike pou {{newProgram}} ap retire aplikasyon {{currentPrograms}} yo pou {{memberNames}}. {{memberNames}} pa ka aplike pou tout an menm tan. Lè ou soumèt, n ap asire {{memberNames}} tout nan bon pwogram nan.",
      "multipleDescription_self": "Aplike pou {{newProgram}} ap retire aplikasyon {{currentPrograms}} ou yo. Ou pa ka aplike pou tout an menm tan. Lè ou soumèt, n ap asire w ou nan bon pwogram nan.",
      "recommendMedicaidDescription": "{{memberNames}} pa ka aplike pou toude an menm tan. Medicaid gratis epi {{memberNames}} kalifye pou li. Lè ou soumèt, n ap asire {{memberNames}} nan bon pwogram nan.",
      "recommendMedicaidDescription_members": "{{memberNames}} pa ka aplike pou toude an menm tan. Medicaid gratis epi {{memberNames}} tout kalifye pou li. Lè ou soumèt, n ap asire {{memberNames}} tout nan bon pwogram nan.",
      "recommendMedicaidDescription_self": "Ou pa ka aplike pou toude an menm tan. Medicaid gratis epi ou kalifye pou li. Lè ou soumèt, n ap asire w ou nan bon pwogram nan.",
      "recommendMedicaidTitle": "Nou rekòmande pou w aplike pou Medicaid",
      "switchButton": "Chanje pou {{newProgram}}",
      "title": "Ou ka aplike pou yon sèl pwogram"
    },
    "programsFound": "Nou jwenn {{programsCount}} pwogram ki bon pou tout {{householdMembersCount}} moun nan fanmi an.",
    "recentDuplicateDialog": {
      "continueAnyway": "Kontinye kanmenm",
      "description": "Ou te fèk soumèt yon aplikasyon <bold>{{applicationType}}</bold> pou {{memberNames}}. Ou ta dwe soumèt yon lòt aplikasyon sèlman si gen yon bagay ki chanje.",
      "multipleDescription": "Ou te fèk soumèt aplikasyon <bold>{{applicationTypes}}</bold> pou {{memberNames}}. Ou ta dwe soumèt yon lòt aplikasyon sèlman si gen yon bagay ki chanje.",
      "title": "Ou te fèk soumèt yon aplikasyon"
    },
    "startButton": "Kòmanse aplikasyon yo"
  },
  "applicationMaritalStatusScreen": {
    "description": "Nou mete estati maryaj la selon enfòmasyon ou te bay yo. Tanpri verifye yo.",
    "needsMaritalStatus": "Bezwen eta sivil",
    "title": "Estati maryaj kounye a"
  },
  "applicationOtherStatusesScreen": {
    "conditions": {
      "americanIndianOrAlaskaNative": "Endyen Ameriken oswa Natif natal Alaska",
      "needsHelpDailyActivities": "Bezwen èd pou aktivite chak jou",
      "studentFullTime18to20": "Etidyan aplentan (laj 18 - 20)",
      "veteranOrMilitaryMember": "Ansyen konbatan oswa manm militè"
    },
    "description": "Tanpri chwazi tout sitiyasyon ki konsène moun nan fanmi an.",
    "errors": {
      "unableToUpdateHouseholdMembers": "Nou pa t kapab sove chanjman sa yo. Tanpri reseye."
    },
    "title": "Lòt estati"
  },
  "applicationSection": {
    "applications": "Aplikasyon yo",
    "beginYourApplicationCompact": "Aplike nan 15 minit oswa mwens",
    "beginYourApplicationProcess": "Kòmanse aplikasyon an pou w jwenn asirans nan 15 minit oswa mwens",
    "continueQuickApply": "Kontinye Aplikasyon Rapid",
    "continueYourApplicationCompact": "Kontinye aplikasyon w lan",
    "continueYourApplicationProcess": "Kontinye aplikasyon an pou w jwenn asirans nan 15 minit oswa mwens",
    "newQuickApply": "Nouvo Aplikasyon Rapid",
    "quickApply": "Aplikasyon Rapid"
  },
  "applicationSubmitScreen": {
    "description": "Ou fini tout etap yo. Lè ou pare, voye aplikasyon ou yo anba a.",
    "hintMessage": "Ou p ap ka fè chanjman ankò lè ou fin voye yo, donk asire w tout bagay korèk.",
    "partialFailure": "Gen kèk nan aplikasyon asirans ou yo ki ka pa voye. Tanpri tcheke yo nan lis aplikasyon w lan.",
    "submitButton": "Voye aplikasyon yo",
    "success": "Aplikasyon yo pati avèk siksè.",
    "title": "Tout bagay pare!"
  },
  "applicationTaxInformationScreen": {
    "description": "Dapre sa ou di nou, men sa nou panse ki estati taks tout moun. Tanpri verifye epi korije si sa nesesè.",
    "errors": {
      "unableToUpdateRelationship": "Nou pa t kapab chanje rapò sa a. Tanpri reseye."
    },
    "memberCard": {
      "dependentOf": "Moun ki depann de: {{name}}",
      "dependents": "Moun ki depann sou li: {{name}}",
      "memberDialog": {
        "description": "Verifye detay taks moun sa a si sa nesesè.",
        "saveAndReturn": "Anrejistre epi tounen",
        "taxClaimedAsDependentStatus": "Èske gen yon moun k ap deklare moun sa a sou taks li?",
        "taxDependentsClaimedStatus": "Èske moun sa a gen moun l ap deklare sou taks li?",
        "taxFilingStatus": "Estati Taks",
        "title": "Enfòmasyon sou taks – {{name}}",
        "who": "Kiyès?"
      }
    },
    "needsTaxInformation": "Bezwen enfòmasyon taks",
    "success": "Enfòmasyon sou taks mete ajou avèk siksè",
    "title": "Enfòmasyon sou taks"
  },
  "applicationWorkAndIncomeScreen": {
    "addAnotherIncome": "Ajoute yon lòt revni",
    "addIncome": "Ajoute yon revni",
    "description": "Ajoute enfòmasyon sou travay ak lajan k ap antre pou chak moun nan fanmi an.",
    "incomeTypes": {
      "ALIMONY": "Pansyon alimantè",
      "EMPLOYED": "Anplwaye",
      "NONE": "Okenn",
      "OTHER": "Lòt",
      "PENSION": "Pansyon retrèt",
      "PROPERTY_RENTAL_INCOME": "Lajan lokasyon kay",
      "RETIREMENT_INCOME": "Revni retrèt",
      "SELF_EMPLOYED": "Travay pou kont ou",
      "SSA": "SSA (Sekirite Sosyal)",
      "SSDI": "SSDI (Andikap)",
      "UNEMPLOYED": "San travay",
      "WORKERS_COMPENSATION": "Konpansasyon travayè"
    },
    "memberDialog": {
      "alertDescriptions": {
        "EMPLOYED": "N ap mande w prèv revni sa a pi ta. Prepare fich pay oswa fòm W-2.",
        "OTHER": "N ap mande w prèv revni sa a pi ta. Sa ka lèt benefis oswa lòt dokiman.",
        "SELF_EMPLOYED": "N ap mande w prèv revni sa a pi ta. Sa ka fakti oswa fòm 1099.",
        "UNEMPLOYED": "N ap mande w prèv revni sa a pi ta. Prepare lèt benefis chomaj ou yo."
      },
      "employerName": "Non patwon an",
      "enterName": "Antre non an",
      "enterTypeOfWork": "Antre ki kalite travay",
      "grossMonthlyIncome": "Lajan ou fè pa mwa (anvan taks)",
      "payFrequency": "Konbyen fwa yo peye w",
      "selfEmploymentNetMonthlyIncome": "Lajan ou fè pa mwa apre ou fin peye depans travay la",
      "title": "Chwazi kalite revni",
      "typeOfWork": "Kalite travay",
      "unemploymentCompensationStatus": "Èske ou resevwa kòb chomaj?",
      "workWeekHours": "Kantite èdtan pa senmenn"
    },
    "monthlyIncome": "{{monthlyIncome}} / pa mwa",
    "title": "Travay ak Revni"
  },
  "applicationsListScreen": {
    "applicationDate": "DD/MM/YYYY [a] h:mm A",
    "inProgress": "An kous",
    "noApplications": "Ou pa gen okenn aplikasyon ankò.",
    "submitted": "Voye deja",
    "title": "Aplikasyon {{applicationType}}"
  },
  "authScreen": {
    "appleSignInFailed": "Nou pa t kapab konekte w ak Apple. Tanpri reseye oswa itilize yon lòt fason.",
    "checkYourEmail": "Tcheke imèl ou",
    "checkYourSpam": "Ou pa jwenn li? Tcheke bwat \"Spam\" lan oswa tann kèk minit.",
    "continueWithApple": "Kontinye ak Apple",
    "continueWithGoogle": "Kontinye ak Google",
    "dataSecured": "Enfòmasyon ou yo an sekirite nan men nou. Nou respekte lwa HIPAA ak SOC 2.",
    "emailInput": "Adrès imèl",
    "googleSignInFailed": "Nou pa t kapab konekte w ak Google. Tanpri reseye oswa itilize yon lòt fason.",
    "identifierInput": "Imèl oswa non itilizatè",
    "invalidIdentifier": "Antre yon adrès imèl oswa yon non itilizatè ki valab.",
    "subtitle": "Antre imèl ou oswa non itilizatè ou pou w kontinye.",
    "title": "Konekte oswa kreye yon kont",
    "weSentALink": "Nou voye yon lyen sekirite nan <bold>{{email}}</bold>. Klike sou lyen an pou w kontinye.",
    "youAgree": "Lè w kontinye, ou dakò ak <underline><colorEmphasis>Kondisyon Itilizasyon</colorEmphasis></underline> ak <privacyLink><colorEmphasis>Règleman sou Pridans</colorEmphasis></privacyLink> nou yo."
  },
  "brokerConsent": {
    "noButton": "Non mèsi",
    "recommendedBadge": "Rekòmande",
    "yesButton": "Wi, konekte m"
  },
  "brokerConsentScreen": {
    "continueWithMedicaidOnlyButton": "Kontinye ak Medicaid sèlman",
    "continueWithoutAgentButton": "Kontinye san yon ajan",
    "declineCard": {
      "applyLink": "Aplike pou {{program}}",
      "fallbackWithMedicaid": "Ou ka toujou kontinye aplikasyon Medicaid ou a isit la. Pointcare ka okipe aplikasyon Medicaid ou a san yon ajan.",
      "fallbackWithoutMedicaid": "Ou ka toujou kontinye aplikasyon ou a isit la. Si w fini kounye a, Pointcare ap ka ede w lè bezwen kouvèti w yo chanje.",
      "selfEnrollmentWarning": "San yon ajan, w ap bezwen enskri nan {{programs}} pou kont ou.",
      "title": "Chwazi “Wi, konekte m” pou w jwenn plis nan Pointcare"
    },
    "subtitle": "Nou pral konekte w lè li lè pou enskri, epi nou pral pataje sèlman sa ki nesesè pou ede w.",
    "subtitleWithIndividual": "Nou pral konekte w lè li lè pou enskri, epi nou pral pataje sèlman sa ki nesesè pou ede w. Si w ap aplike pou Medicare, ajan sa a se {{brokerName}}.",
    "subtitleWithIndividualLicense": "Nou pral konekte w lè li lè pou enskri, epi nou pral pataje sèlman sa ki nesesè pou ede w. Si w ap aplike pou Medicare, ajan sa a se {{brokerName}} (Lisans #: {{licenseNumber}}).",
    "subtitleWithOrganization": "Nou pral konekte w lè li lè pou enskri, epi nou pral pataje sèlman sa ki nesesè pou ede w. Si w ap aplike pou Medicare, ajan sa a ap soti nan {{brokerName}}.",
    "subtitleWithOrganizationLicense": "Nou pral konekte w lè li lè pou enskri, epi nou pral pataje sèlman sa ki nesesè pou ede w. Si w ap aplike pou Medicare, ajan sa a ap soti nan {{brokerName}} (Lisans #: {{licenseNumber}}).",
    "title": "Konekte ak yon ajan asirans ki gen lisans pou eksplore opsyon Medicare ak/oswa Mache Asirans Sante ACA epi jwenn èd pou fini enskripsyon an"
  },
  "camera": {
    "grantPermission": "Bay pèmisyon",
    "permissionDescription": "Pou w ka pran foto dokiman w yo, tanpri pèmèt nou sèvi ak kamera nan paramèt telefòn ou.",
    "permissionRequired": "Nou bezwen sèvi ak kamera w la.",
    "photoCount": "{{count}} foto pran",
    "tapToCapture": "Peze bouton an pou w pran yon foto"
  },
  "cesSurvey": {
    "feedbackLabel": "Kisa ki te difisil?",
    "feedbackPlaceholder": "Di nou plis",
    "optionalLabel": "Opsyonèl",
    "questions": {
      "consentFormSigned": "Konbyen li te fasil pou konprann sa ou t ap siyen an?",
      "householdMemberAdded": "Konbyen li te fasil pou ajoute yon manm nan fwaye a?",
      "incomeAdded": "Konbyen li te fasil pou ajoute revni?"
    },
    "scoreEasy": "Fasil",
    "scoreHard": "Difisil",
    "scoreOk": "Nòmal",
    "scoreVeryEasy": "Trè fasil",
    "scoreVeryHard": "Trè difisil",
    "thanksDescription": "Kòmantè ou yo ede nou amelyore.",
    "thanksTitle": "Mèsi!"
  },
  "consentDocuments": {
    "addSignature": "Ajoute siyati",
    "description": "Siyen anba a pou nou ka ede w.",
    "documentTitle": "Pèmisyon pou pataje enfòmasyon (PDF)",
    "grant1": "Siveye asirans ou epi rezoud pwoblèm yo byen vit",
    "grant2": "Reponn pou ou si yo mande enfòmasyon - pa gen lèt k ap pèdi",
    "grant3": "Voye aplikasyon ak renouvèlman, epi swiv yo pou w pa janm manke yon dat limit",
    "grant4": "Kontakte ou pou rezon maketing pa telefòn regilye oswa otomatik, mesaj vwa, ak mesaj tèks",
    "grantHealthPlanSelection": "Aplike chwa plan sante ak doktè ou (lè li disponib) nan kouvèti ou",
    "grantSubtitle": "Men sa sa enkli:",
    "healthPlanAvailabilityError": "Nou pa t kapab verifye plan sante ki disponib yo. Tanpri eseye ankò anvan ou siyen.",
    "signatureCountsAsInitials": "Siyati ou konte tou kòm inisyal ou sou fòm nan kote sa aplikab.",
    "title": "Jere Asirans Fanmi Ou",
    "viewDocument": "Wè dokiman an"
  },
  "coverage": {
    "code": "Kòd:",
    "coverageStatus": "Estati asirans",
    "inProgress": "An kous",
    "isCovered": "{{name}} gen asirans nan {{programs}}.",
    "lastCheck": "Dènye verifikasyon",
    "lastCheckDateFormat": "DD/MM/YYYY",
    "lastCheckWithDate": "Dènye verifikasyon {{date}}",
    "noMatchingRecord": "Nou pa ka jwenn asirans ou an. Tanpri tcheke enfòmasyon yo epi reseye.",
    "planName": "Non plan an",
    "primaryCareProvider": "Doktè prensipal",
    "programCoverage": "Asirans {{program}}",
    "programListing": {
      "medicaid": "<bold>Medicaid</bold>",
      "medicare": "<bold>Medicare</bold>",
      "medicareAndMedicaid": "<bold>Medicare</bold> ak <bold>Medicaid</bold>"
    },
    "serviceTypes": "Kalite sèvis",
    "status": {
      "checking": "N ap verifye asirans...",
      "checkingShort": "N ap verifye...",
      "covered": "Gen asirans",
      "coveredBy": "Asire nan {{ programs }}",
      "notCovered": "Pa gen asirans",
      "unknown": "Nou pa konnen estati asirans la",
      "unknownShort": "Enkoni"
    },
    "updateProfileInformation": "Mete enfòmasyon pwofil ajou"
  },
  "createPasswordScreen": {
    "passwordInputLabel": "Modpas",
    "passwordInputPlaceholder": "Kreye yon modpas",
    "passwordRequirement": "Sèvi ak omwen 10 karaktè.",
    "subtitle": "Pwoteje kont ou a avèk yon modpas solid pou w ka kontinye.",
    "title": "Kreye yon modpas"
  },
  "createUsernameAccountScreen": {
    "passwordInputLabel": "Modpas",
    "passwordInputPlaceholder": "Kreye yon modpas",
    "subtitle": "Pwoteje kont ou a avèk yon modpas solid pou w ka kontinye.",
    "title": "Kreye yon modpas"
  },
  "dateOfBirthInput": {
    "dayPlaceholder": "JJ",
    "monthPlaceholder": "MM",
    "yearPlaceholder": "AAAA"
  },
  "eligibilityHouseholdIncomeScreen": {
    "description1": "Sèvi ak revni TOTAL (anvan taks) pou pifò revni yo. Si ou travay pou kont ou, sèvi ak revni nèt (apre depans travay).",
    "description2": "Sa gen ladan l estimasyon revni pou tout moun k ap viv avèk ou:",
    "hideBreakdown": "Kache detay yo",
    "householdIncomeCalculator": {
      "annualDescription": "Antre revni chak ane pou chak moun pou nou ka kalkile total la",
      "biWeeklyDescription": "Antre revni chak de senmenn pou chak moun",
      "monthlyDescription": "Antre revni chak mwa pou chak moun",
      "period": {
        "annual": "ane",
        "biWeekly": "2 senmenn",
        "monthly": "mwa"
      },
      "title": "Kalkile revni ou",
      "totalIncomeTitle": "Total revni fanmi an:",
      "totalIncomeValue": "{{total}} / {{period}}",
      "useRange": "Sèvi ak {{label}}"
    },
    "incomePeriod": {
      "annual": "Chak ane",
      "biWeekly": "Chak de senmenn",
      "monthly": "Chak mwa"
    },
    "incomeRange": {
      "0-1800": "$0 - $1,800",
      "0-3700": "$0 - $3,700",
      "0-44400": "$0 - $44,400",
      "1600-2600": "$1,600 - $2,600",
      "2500-3000": "$2,500 - $3,000",
      "3000-3300": "$3,000 - $3,300",
      "3300+": "$3,300 oswa plis",
      "3500-5600": "$3,500 - $5,600",
      "43000-67000": "$43,000 - $67,000",
      "5500-6500": "$5,500 - $6,500",
      "6500-7000": "$6,500 - $7,000",
      "66000-78000": "$66,000 - $78,000",
      "7000+": "$7,000 oswa plis",
      "78000-83000": "$78,000 - $83,000",
      "83000+": "$83,000 oswa plis"
    },
    "showBreakdown": "Ou bezwen èd pou kalkile? Montre detay",
    "title": "Ki kantite kòb anviwon fanmi an fè?",
    "updateError": "Nou pa t kapab sove revni w. Tanpri reseye."
  },
  "eligibilityHouseholdMembers": {
    "title": "Fanmi w",
    "you": "Ou"
  },
  "eligibilityLiveAndCareScreen": {
    "description": "Yo dwe <bold>viv avèk ou</bold> pandan <bold>plis pase mwatye ane a</bold> epi ou dwe <bold>peye plis pase mwatye</bold> nan <bold>depans li yo</bold> (manje, kay, lekòl, ak bòdwo lopital).",
    "formDescription": "Ajoute tout timoun, pitit pitit, oswa timoun w ap gade ki gen mwens pase 19 ane k ap viv avèk ou epi w ap ede finansyèman.",
    "formTitle": "Pale nou de timoun w ap sipòte yo",
    "supporterDescription": "Yo dwe <bold>viv avèk {{supporterFirstName}}</bold> pandan <bold>plis pase mwatye ane a</bold> epi {{supporterFirstName}} dwe <bold>peye plis pase mwatye</bold> nan depans yo.",
    "supporterFormDescription": "Ajoute tout timoun k ap viv avèk {{supporterFirstName}}.",
    "supporterFormTitle": "Pale nou de timoun {{supporterFirstName}} yo",
    "supporterTitle": "Èske {{supporterFirstName}} ap viv epi pran swen timoun ki gen mwens pase 19 ane?",
    "title": "Èske w ap viv epi pran swen timoun ki gen mwens pase 19 ane?"
  },
  "eligibilityMaritalStatusScreen": {
    "description": "Sa ede nou konprann fanmi ou pou nou konnen ki pwogram ki bon pou ou.",
    "formDescription": "Nou bezwen kèk enfòmasyon de baz sou madanm, mari, oswa patnè ou pou nou konnen si w elijib.",
    "formTitle": "Pale nou de mari, madanm, oswa patnè ou",
    "supporterFormDescription": "Nou bezwen kèk enfòmasyon sou mari, madanm oswa patnè {{supporterFirstName}}.",
    "supporterFormTitle": "Pale nou de mari, madanm oswa patnè {{supporterFirstName}}",
    "supporterTitle": "Ki estati maryaj {{supporterFirstName}}?",
    "title": "Ki estati maryaj ou?"
  },
  "eligibilityParentGuardianStudentScreen": {
    "description": "Ou dwe <bold>peye plis pase mwatye</bold> nan <bold>depans yo</bold> (manje, kay, lekòl, ak bòdwo lopital).",
    "formDescription": "Ajoute tout etidyan aplentan ki gen ant 18 ak 21 ane ke ou se paran oswa gadyen yo epi w ap ede finansyèman.",
    "formTitle": "Pale nou de etidyan w ap sipòte a",
    "supporterDescription": "{{supporterFirstName}} dwe <bold>peye plis pase mwatye</bold> nan depans yo.",
    "supporterFormDescription": "Ajoute tout etidyan aplentan ant 18 ak 21 ane ke {{supporterFirstName}} ap ede finansyèman.",
    "supporterFormTitle": "Pale nou de etidyan {{supporterFirstName}} ap sipòte a",
    "supporterTitle": "Èske {{supporterFirstName}} se paran oswa gadyen yon etidyan aplentan ant 18 ak 21 ane l ap ede finansyèman?",
    "title": "Èske w se paran oswa gadyen yon etidyan aplentan ant 18 ak 21 ane w ap ede finansyèman?"
  },
  "eligibilitySomeoneSupportsYou": {
    "description": "Sa gen ladan l manje, kay, lekòl, ak bòdwo lopital.",
    "errors": {
      "updateFailed": "Nou pa t kapab sove chanjman sa yo. Tanpri reseye."
    },
    "formDescription": "Ajoute moun ki peye plis pase mwatye nan depans ou, tankou yon paran, yon gadyen, oswa yon lòt fanmi.",
    "formTitle": "Pale nou de moun k ap sipòte w la",
    "options": {
      "disabled": "Wi, mwen gen yon andikap epi mwen viv tout ane a ak moun k ap sipòte m nan.",
      "fullTimeStudent": "Wi, mwen se yon etidyan aplentan epi paran m oswa gadyen m ap sipòte m.",
      "personSupportsMe": "Wi, mwen viv plis pase mwatye ane a ak moun k ap sipòte m nan.",
      "relativeSupportsMe": "Wi, mwen viv plis pase mwatye ane a ak yon fanmi k ap sipòte m."
    },
    "title": "Èske gen yon moun ki peye plis pase mwatye nan depans ou chak ane?"
  },
  "eligibilitySpecialConditionsScreen": {
    "addDetails": "Ajoute detay",
    "conditions": {
      "blind": "Gen yon moun ki avèg",
      "breastCancer": "Gen yon moun ki gen kansè nan tete",
      "cervicalCancer": "Gen yon moun ki gen kansè nan matris",
      "disabled": "Gen yon moun ki gen andikap (SSDI)",
      "fosterCare": "Gen yon moun ki te nan sistèm plasman (foster care) lè li te gen 18 an",
      "pregnant": "Gen yon moun ki ansent"
    },
    "description": "Tanpri chwazi tout sitiyasyon ki konsène moun nan fanmi an.",
    "errors": {
      "allUpdatesFailed": "Nou pa t kapab sove chanjman sa yo. Tanpri reseye."
    },
    "pregnancyDetails": {
      "estimatedDueDate": "Dat akouchman prevwa",
      "numberOfBabies": "Konbyen bebe w ap tann",
      "title": "Detay sou gwosès la"
    },
    "pregnancyInfo": {
      "babiesWithCount_one": "{{count}} bebe • Akouchman {{date}}",
      "babiesWithCount_other": "{{count}} bebe • Akouchman {{date}}"
    },
    "title": "Ka espesyal nan fanmi an"
  },
  "eligibilitySupportDisabledIndividualScreen": {
    "description": "Sa ka nenpòt moun — timoun, frè/sè, granparan, oswa lòt moun — kèlkeswa laj li. Ou dwe <bold>peye plis pase mwatye</bold> nan <bold>depans li yo</bold>.",
    "formDescription": "Ajoute tout moun ki gen andikap k ap viv avèk ou tout ane a epi w ap ede finansyèman.",
    "formTitle": "Pale nou de moun ki gen andikap w ap sipòte a",
    "supporterDescription": "Sa ka nenpòt moun. {{supporterFirstName}} dwe <bold>peye plis pase mwatye</bold> nan depans moun sa a.",
    "supporterFormDescription": "Ajoute tout moun ki gen andikap k ap viv ak {{supporterFirstName}} tout ane a.",
    "supporterFormTitle": "Pale nou de moun {{supporterFirstName}} ap sipòte a",
    "supporterTitle": "Èske {{supporterFirstName}} ap ede yon moun ki gen andikap k ap viv avè l tout ane a?",
    "title": "Èske w ap ede yon moun ki gen andikap k ap viv avè w tout ane a?"
  },
  "eligibilitySupportOtherRelativesScreen": {
    "description": "Yo dwe <bold>viv avèk ou</bold> pou <bold>plis pase mwatye ane a</bold> epi ou dwe <bold>peye plis pase mwatye</bold> nan depans yo.",
    "formDescription": "Ajoute tout fanmi (pwòch oswa lwen) k ap viv avèk ou epi w ap ede finansyèman.",
    "formTitle": "Pale nou de fanmi w ap sipòte yo",
    "supporterDescription": "Yo dwe <bold>viv avèk {{supporterFirstName}}</bold> pou plis pase mwatye ane a.",
    "supporterFormDescription": "Ajoute tout fanmi k ap viv ak {{supporterFirstName}} epi l ap ede finansyèman.",
    "supporterFormTitle": "Pale nou de fanmi {{supporterFirstName}} ap sipòte yo",
    "supporterTitle": "Èske {{supporterFirstName}} ap ede lòt fanmi k ap viv avè l?",
    "title": "Èske w ap ede lòt fanmi k ap viv avè w?"
  },
  "homeScreen": {
    "addMember": "Ajoute yon moun",
    "applicationSubmittedCard_multiple": "Ou soumèt aplikasyon <programs /> pou {{memberNames}}. N ap egzamine yo epi n ap kontakte w si nou bezwen yon bagay.",
    "applicationSubmittedCard_single": "Ou soumèt yon aplikasyon <programs /> pou {{memberNames}}. N ap egzamine l epi n ap kontakte w si nou bezwen yon bagay.",
    "applicationSubmittedCard_singleMarketplace": "Ou soumèt yon aplikasyon <programs /> pou {{memberNames}}. N ap egzamine l epi n ap kontakte w si nou bezwen yon bagay.",
    "checkEligibility": "Verifye eligibilite fanmi an",
    "checkEligibilityCompact": "Verifye eligibilite",
    "devScenarioActive": "Senaryo similye a aktif — tablo a ap montre done tès.",
    "devScenarioReset": "Reyinisyalize",
    "eligibilityCardCompactNotStarted": "Wè nan ki pwogram ou ka antre",
    "eligibilityCardCompactStarted": "Kontinye pou w wè nan ki pwogram ou ka antre",
    "eligibilityCardNotStarted": "Kòmanse verifikasyon rapid la pou w wè nan ki pwogram fanmi an ka antre",
    "eligibilityCardStarted": "Kontinye verifikasyon an pou w wè ki pwogram ki bon pou fanmi an",
    "household": "Fanmi",
    "logout": "Dekonekte",
    "nextSteps": "Pwochen etap yo",
    "recheckEligibility": "Verifye ankò"
  },
  "householdMemberScreen": {
    "applicantDocuments": "Dokiman aplikan an",
    "checkCoverage": "Verifye asirans",
    "deleteButton": "Retire {{memberFullName}} nan fanmi an",
    "deleteDialog": {
      "description": "Sa pral retire {{memberFullName}} nèt nan fanmi w. Tout enfòmasyon ak dokiman li yo pral efase nèt.\nOu p ap ka ranvèse aksyon sa a.",
      "title": "Retire yon moun nan fanmi an"
    },
    "deleteToast": {
      "error": "Nou pa t kapab wete moun sa a nan fanmi an. Tanpri reseye.",
      "success": "Nou retire moun sa a nan fanmi an avèk siksè"
    },
    "profileInformation": "Enfòmasyon pwofil"
  },
  "landingScreen": {
    "goToAuth": "Ale nan paj koneksyon"
  },
  "languageSelectorModal": {
    "title": "Chwazi lang"
  },
  "languages": {
    "arabicDescription": "Arab",
    "chineseSimplifiedDescription": "Chinwa Senplifye",
    "englishDescription": "Angle",
    "haitianCreoleDescription": "Kreyòl Ayisyen",
    "russianDescription": "Ris",
    "spanishDescription": "Panyòl",
    "tagalogDescription": "Tagalòg",
    "vietnameseDescription": "Vyetnamyen"
  },
  "memberFormSubmission": {
    "error": "Nou pa t kapab sove chanjman sa yo. Tanpri reseye.",
    "success": "Enfòmasyon yo mete ajou avèk siksè"
  },
  "mfaPhoneScreen": {
    "phoneNumberLabel": "Nimewo telefòn",
    "phoneNumberPlaceholder": "(555) 000-0000",
    "sendVerificationCodeText": "N ap voye yon kòd verifikasyon ba ou.",
    "subtitle": "N ap sèvi ak sa pou nou kenbe kont ou an sekirite.",
    "title": "Ki nimewo telefòn ou?"
  },
  "mfaVerifyScreen": {
    "getNewCode": "Mande yon lòt kòd",
    "subtitle": "Tanpri antre kòd 6 chif nou voye nan\n<bold>{{phoneNumber}}</bold>",
    "title": "Nou voye yon kòd ba ou",
    "verificationCodeLabel": "Kòd Verifikasyon"
  },
  "notFound": {
    "cta": "Tounen nan akèy",
    "description": "Paj w ap chèche a pa la ankò.",
    "title": "Nou pa jwenn paj sa a."
  },
  "npsSurveyScreen": {
    "highFeedbackLabel": "Kisa ou te pi renmen nan Pointcare? (opsyonèl)",
    "highFeedbackPlaceholder": "Di nou sa ki te parèt pi bon",
    "lowFeedbackLabel": "Kisa nou ta ka fè pi byen? (opsyonèl)",
    "lowFeedbackPlaceholder": "Di nou sa ki pa t mache byen...",
    "mediumFeedbackLabel": "Kisa ki ta fè ou bay sa a 10? (opsyonèl)",
    "mediumFeedbackPlaceholder": "Kisa ki ta fè li pi bon...",
    "scaleHighLabel": "→ Trè posib",
    "scaleLowLabel": "→ Pa posib ditou",
    "submitButton": "Voye fidbak",
    "subtitle": "Nou pa janm pataje repons ou yo ak pwogram ou te aplike yo.",
    "success": "Fidbak la voye avèk siksè.",
    "testimonialLabel": "Èske nou ka pataje fidbak ou sou sit entènèt nou an pou ede plis moun jwenn asirans? N ap itilize sèlman prenon ou.",
    "title": "Ki chans pou ou rekòmande Pointcare bay yon zanmi oswa yon manm fanmi?"
  },
  "onboarding": {
    "benefits": {
      "description": "Pointcare ede plis pase 1.8M pasyan toupatou Ozetazini jwenn epi kenbe asirans sante yo.",
      "firstItem": "Konnen kiyès ki elijib nan 5 minit",
      "firstItem_AGING_INTO_MEDICARE": "Jwenn bon asirans Medicare la",
      "firstItem_AGING_INTO_MEDICARE_awareness": "Rete enfòme sou dat limit yo",
      "firstItem_LAPSE": "Konnen kiyès ki elijib nan 5 minit",
      "firstItem_QR_CODE": "Konnen kiyès ki elijib nan 5 minit",
      "firstItem_RECURRING_WORK_REQUIREMENT": "Pa janm rate yon dat limit enpòtan",
      "firstItem_REDETERMINATION": "Pa janm rate yon dat limit enpòtan",
      "firstItem_SELF_PAY_CONVERSION": "Konnen kiyès ki elijib nan 5 minit",
      "firstItem_SERVICE_INTRODUCTION_medicaid": "Pa janm rate yon dat limit enpòtan",
      "firstItem_SERVICE_INTRODUCTION_medicare": "Verifye benefis tout moun nan 5 minit",
      "freeToUse": "Èd gratis - pa gen frè kache",
      "infoIsPrivate": "Tout enfòmasyon w yo rete prive",
      "title": "{{clinicName}} fè patenarya ak Pointcare pou sipòte fanmi w",
      "titleNoClinic": "Pointcare la pou sipòte fanmi ou"
    },
    "buttons": {
      "createMyProfile": "Kreye pwofil mwen",
      "getStarted": "Kòmanse"
    },
    "concerns": {
      "description": "Chwazi opsyon ki pi enpòtan pou ou a — n ap moutre w ki jan nou ka ede w.",
      "description_SERVICE_INTRODUCTION_medicare": "Chwazi opsyon ki pi byen dekri asirans sa a.",
      "title": "Kisa ki plis ba w pwoblèm lè w ap chèche asirans pou fanmi w?",
      "title_SERVICE_INTRODUCTION_medicare": "Ki asirans Medicare fanmi w genyen?"
    },
    "figuringOutWhenToRenew": {
      "option": "Konnen ki lè pou renouvle",
      "subtext": "N ap swiv dat renouvèlman pou tout moun epi n ap fè w konnen anvan li twò ta."
    },
    "figuringOutWhenToSubmitRequirements": {
      "option": "Konnen ki lè pou voye dokiman yo mande",
      "subtext": "N ap swiv dat limit yo pou tout moun epi n ap fè w konnen anvan li twò ta."
    },
    "imNotSure": {
      "option": "Mwen pa sèten",
      "subtext": "N ap asire nou plan chak moun toujou bon pou yo."
    },
    "intro": {
      "description": "Anpil moun pa peye anyen. Gen lòt ki peye sèlman $20–30 pa mwa. N ap poze w kèk kesyon senp pou n jwenn pi bon plan pou tout moun.",
      "description_AGING_INTO_MEDICARE": "Ou dwe ap resevwa anpil òf kounye a. Antan k doktè fanmi w, n ap ede w jwenn bon plan an.",
      "description_AGING_INTO_MEDICARE_awareness": "Ou dwe ap resevwa anpil òf kounye a. Antan k doktè fanmi w, n ap ede w jwenn bon plan an.",
      "description_LAPSE": "7 sou 10 moun ka re-elijib pou asirans gratis oswa ki pa koute chè. N ap ede w nan chak etap.",
      "description_QR_CODE": "Anpil moun pa peye anyen. Gen lòt ki peye sèlman $20–30 pa mwa. N ap poze w kèk kesyon senp pou n jwenn pi bon plan pou tout moun.",
      "description_RECURRING_WORK_REQUIREMENT": "Yon nouvo lwa mande prèv revni. N ap tcheke si tout moun an règ oswa si yo pa bezwen sa, epi n ap ede w apre sa.",
      "description_REDETERMINATION": "Ou bezwen konfime oswa mete enfòmasyon fanmi w ajou pou yo pa pèdi asirans lan. N ap ede w nan chak etap.",
      "description_SELF_PAY_CONVERSION": "Anpil moun pa peye anyen. Gen lòt ki peye sèlman $20–30 pa mwa.",
      "description_SERVICE_INTRODUCTION_medicaid": "N ap siveye asirans tout moun, ede ak renouvèlman, epi gide w nan tout sa k parèt - gratis.",
      "description_SERVICE_INTRODUCTION_medicare": "N ap ede w konprann asirans tout moun, jwenn plis benefis, epi asire w pa rate anyen.",
      "title": "Jwenn asirans sante pa bezwen difisil. Fanmi w ka elijib pou <colorEmphasis>plan gratis oswa ki pa koute chè</colorEmphasis>.",
      "title_AGING_INTO_MEDICARE": "Sanble gen yon moun nan fanmi w ki elijib pou Medicare depi <colorEmphasis>{{count}} mwa</colorEmphasis>. Nou la pou nou ede.",
      "title_AGING_INTO_MEDICARE_awareness_one": "Sanble gen yon moun nan fanmi w ki pral elijib pou Medicare <colorEmphasis>nan {{monthsToTurning65}} mwa</colorEmphasis>. Nou la pou nou ede.",
      "title_AGING_INTO_MEDICARE_awareness_other": "Sanble gen yon moun nan fanmi w ki pral elijib pou Medicare <colorEmphasis>nan {{monthsToTurning65}} mwa</colorEmphasis>. Nou la pou nou ede.",
      "title_AGING_INTO_MEDICARE_one": "Sanble gen yon moun nan fanmi w ki elijib pou Medicare depi <colorEmphasis>{{count}} mwa</colorEmphasis>. Nou la pou nou ede.",
      "title_AGING_INTO_MEDICARE_other": "Sanble gen yon moun nan fanmi w ki elijib pou Medicare depi <colorEmphasis>{{count}} mwa</colorEmphasis>. Nou la pou nou ede.",
      "title_AGING_INTO_MEDICARE_zero": "Sanble gen yon moun nan fanmi w ki vin elijib pou Medicare <colorEmphasis>apati mwa sa a</colorEmphasis>. Nou la pou nou ede.",
      "title_LAPSE": "Sanble gen yon moun nan fanmi w ki pèdi asirans {{payerName}} li nan dat <colorEmphasis>{{lapseDate}}</colorEmphasis>. Nou la pou nou ede yo jwenn asirans ankò.",
      "title_QR_CODE": "Fanmi w ka elijib pou <colorEmphasis>asirans sante gratis oswa ki pa koute chè</colorEmphasis>. Ann verifye sa.",
      "title_RECURRING_WORK_REQUIREMENT_one": "Sanble gen yon moun nan fanmi w ki gen yon egzijans travay {{payerName}} ki dwe fèt <colorEmphasis>nan {{count}} mwa</colorEmphasis>. Ann kenbe yo asire.",
      "title_RECURRING_WORK_REQUIREMENT_other": "Sanble gen yon moun nan fanmi w ki gen yon egzijans travay {{payerName}} ki dwe fèt <colorEmphasis>nan {{count}} mwa</colorEmphasis>. Ann kenbe yo asire.",
      "title_RECURRING_WORK_REQUIREMENT_zero": "Sanble gen yon moun nan fanmi w ki gen yon egzijans travay {{payerName}} ki dwe fèt <colorEmphasis>mwa sa a</colorEmphasis>. Ann kenbe yo asire.",
      "title_REDETERMINATION_one": "Sanble gen yon moun nan fanmi w ki gen yon renouvèlman {{payerName}} ki dwe fèt <colorEmphasis>nan {{count}} mwa</colorEmphasis>. Ann kenbe yo asire.",
      "title_REDETERMINATION_other": "Sanble gen yon moun nan fanmi w ki gen yon renouvèlman {{payerName}} ki dwe fèt <colorEmphasis>nan {{count}} mwa</colorEmphasis>. Ann kenbe yo asire.",
      "title_REDETERMINATION_zero": "Sanble gen yon moun nan fanmi w ki gen yon renouvèlman {{payerName}} ki dwe fèt <colorEmphasis>mwa sa a</colorEmphasis>. Ann kenbe yo asire.",
      "title_SERVICE_INTRODUCTION_medicaid": "Nou la pou nou ede fanmi w <colorEmphasis>rete asire nan {{payerName}}.</colorEmphasis>",
      "title_SERVICE_INTRODUCTION_medicare": "Èske fanmi w ap <colorEmphasis>jwenn tout avantaj nan {{payerName}}?</colorEmphasis> Nou la pou nou ede."
    },
    "keepingMyCurrentDoctors": {
      "option": "Kenbe menm doktè mwen genyen yo",
      "subtext": "N ap ede w jwenn yon plan ki gen doktè fanmi w deja wè yo."
    },
    "meetingRequirements": {
      "option": "Respekte egzijans yo",
      "subtext": "N ap ede tout moun lè li rive lè pou ranpli egzijans travay yo."
    },
    "missingEnrolmentDeadline": {
      "option": "Rate dat limit enskripsyon an",
      "subtext": "N ap fè w konnen ki lè pou w enskri pou w pa peye amann."
    },
    "nextSteps": {
      "step1Description": "Pale nou de ou menm",
      "step1Duration": "2 min",
      "step1Title": "Kreye Pwofil",
      "step2Description": "Asirans fanmi w ka genyen",
      "step2Description_AGING_INTO_MEDICARE": "Verifye estati w kounye a",
      "step2Description_AGING_INTO_MEDICARE_awareness": "Verifye estati w kounye a",
      "step2Description_LAPSE": "Asirans fanmi w ka genyen",
      "step2Description_QR_CODE": "Asirans fanmi w ka genyen",
      "step2Description_RECURRING_WORK_REQUIREMENT": "N ap tcheke si tout moun nan nòmal oswa si yo egzante",
      "step2Description_RECURRING_WORK_REQUIREMENT_awareness": "N ap tcheke si tout moun nan nòmal oswa si yo egzante",
      "step2Description_REDETERMINATION": "Ekip nou an ap rele w",
      "step2Description_REDETERMINATION_awareness": "Sa gen ladan l enfòmasyon kontak de baz",
      "step2Description_SELF_PAY_CONVERSION": "Asirans fanmi w ka genyen",
      "step2Description_SERVICE_INTRODUCTION_medicaid": "Verifye estati w kounye a",
      "step2Description_SERVICE_INTRODUCTION_medicare": "Verifye estati w kounye a",
      "step2Description_SERVICE_INTRODUCTION_medicare_partABorD": "Verifye estati w kounye a",
      "step2Duration": "5 min",
      "step2Duration_AGING_INTO_MEDICARE": "2 min",
      "step2Duration_AGING_INTO_MEDICARE_awareness": "2 min",
      "step2Duration_LAPSE": "5 min",
      "step2Duration_QR_CODE": "5 min",
      "step2Duration_RECURRING_WORK_REQUIREMENT": "5 min",
      "step2Duration_RECURRING_WORK_REQUIREMENT_awareness": "5 min",
      "step2Duration_REDETERMINATION": "2 min",
      "step2Duration_SELF_PAY_CONVERSION": "5 min",
      "step2Duration_SERVICE_INTRODUCTION_medicaid": "2 min",
      "step2Duration_SERVICE_INTRODUCTION_medicare": "2 min",
      "step2Duration_SERVICE_INTRODUCTION_medicare_partABorD": "2 min",
      "step2Title": "Jwenn Opsyon Ou Yo",
      "step2Title_AGING_INTO_MEDICARE": "Tcheke Asirans",
      "step2Title_AGING_INTO_MEDICARE_awareness": "Tcheke Asirans",
      "step2Title_LAPSE": "Jwenn Opsyon Ou Yo",
      "step2Title_QR_CODE": "Jwenn Opsyon Ou Yo",
      "step2Title_RECURRING_WORK_REQUIREMENT": "Tcheke Egzijans yo",
      "step2Title_RECURRING_WORK_REQUIREMENT_awareness": "Tcheke Egzijans yo",
      "step2Title_REDETERMINATION": "Mande Èd pou Renouvèlman",
      "step2Title_REDETERMINATION_awareness": "Ajoute Enfòmasyon Fanmi",
      "step2Title_SELF_PAY_CONVERSION": "Jwenn Opsyon Ou Yo",
      "step2Title_SERVICE_INTRODUCTION_medicaid": "Tcheke Asirans",
      "step2Title_SERVICE_INTRODUCTION_medicare": "Tcheke Asirans",
      "step2Title_SERVICE_INTRODUCTION_medicare_partABorD": "Tcheke Asirans",
      "step3Description": "N ap okipe rès la!",
      "step3Description_AGING_INTO_MEDICARE": "N ap okipe rès la!",
      "step3Description_AGING_INTO_MEDICARE_awareness": "N ap kenbe w enfòme",
      "step3Description_LAPSE": "N ap okipe rès la!",
      "step3Description_QR_CODE": "N ap okipe rès la!",
      "step3Description_RECURRING_WORK_REQUIREMENT": "N ap gide w nan sa",
      "step3Description_RECURRING_WORK_REQUIREMENT_awareness": "N ap ede fanmi w respekte egzijans yo",
      "step3Description_REDETERMINATION": "N ap gide w nan sa",
      "step3Description_REDETERMINATION_awareness": "N ap kenbe w pare",
      "step3Description_SELF_PAY_CONVERSION": "N ap okipe rès la!",
      "step3Description_SERVICE_INTRODUCTION_medicaid": "N ap avèti w davans",
      "step3Description_SERVICE_INTRODUCTION_medicare": "Gade sa ki gen nan plan chak moun",
      "step3Description_SERVICE_INTRODUCTION_medicare_partABorD": "Gade plis benefis",
      "step3Duration": "15 min",
      "step3Duration_SERVICE_INTRODUCTION_medicare": "1 min",
      "step3Title": "Voye Aplikasyon",
      "step3Title_AGING_INTO_MEDICARE": "Aplike pou Medicare",
      "step3Title_AGING_INTO_MEDICARE_awareness": "Pare pou Medicare",
      "step3Title_LAPSE": "Voye Aplikasyon",
      "step3Title_QR_CODE": "Voye Aplikasyon",
      "step3Title_RECURRING_WORK_REQUIREMENT": "Voye Egzijans yo",
      "step3Title_RECURRING_WORK_REQUIREMENT_awareness": "Rete Devan nan Egzijans yo",
      "step3Title_REDETERMINATION": "Voye Renouvèlman",
      "step3Title_REDETERMINATION_awareness": "Rete Devan nan Renouvèlman",
      "step3Title_SELF_PAY_CONVERSION": "Voye Aplikasyon",
      "step3Title_SERVICE_INTRODUCTION_medicaid": "Pa Janm Rate yon Dat Limit",
      "step3Title_SERVICE_INTRODUCTION_medicare": "Revize Benefis Ou Yo",
      "step3Title_SERVICE_INTRODUCTION_medicare_partABorD": "Gade Opsyon Medicare",
      "title": "Pare pou w jwenn asirans pou fanmi w?",
      "title_RECURRING_WORK_REQUIREMENT": "Ann kenbe fanmi w asire",
      "title_RECURRING_WORK_REQUIREMENT_awareness": "Ann kenbe fanmi w asire",
      "title_REDETERMINATION": "Ann kenbe fanmi w asire",
      "title_REDETERMINATION_awareness": "Ann kenbe fanmi w asire",
      "title_SERVICE_INTRODUCTION_medicaid": "Ann kenbe fanmi w asire",
      "title_SERVICE_INTRODUCTION_medicare": "Ann kenbe fanmi w asire",
      "title_SERVICE_INTRODUCTION_medicare_partABorD": "Ann kenbe fanmi w asire"
    },
    "notKnowingHowToGetCovered": {
      "option": "Pa konnen ki jan pou jwenn asirans",
      "subtext": "N ap moutre w egzakteman sa pou w fè pou tout moun jwenn asirans."
    },
    "notKnowingImCovered": {
      "option": "Pa konnen kiyès ki gen asirans",
      "subtext": "Nou ka verifye si tout moun gen asirans epi ede w jwenn li si w pa genyen.",
      "subtext_RECURRING_WORK_REQUIREMENT": "N ap verifye asirans tout moun epi ede w jwenn li si w bezwen sa.",
      "subtext_RECURRING_WORK_REQUIREMENT_awareness": "N ap verifye asirans tout moun epi ede w jwenn li si w bezwen sa.",
      "subtext_REDETERMINATION": "N ap verifye asirans tout moun epi ede w jwenn li si w bezwen sa.",
      "subtext_REDETERMINATION_awareness": "N ap verifye asirans tout moun epi ede w jwenn li si w bezwen sa.",
      "subtext_SERVICE_INTRODUCTION_medicaid": "N ap verifye asirans tout moun epi ede w jwenn li si w bezwen sa."
    },
    "paperwork": {
      "option": "Twòp papye oswa papye ki konplike",
      "subtext": "N ap jere tout papye pou tout moun - soti nan asirans rive nan renouvèlman.",
      "subtext_SERVICE_INTRODUCTION": "N ap travay pou doktè fanmi w la pou nou jwenn pi bon opsyon pou sante tout moun."
    },
    "partAB": {
      "option": "Pati A ak B (Medicare)",
      "subtext": "N ap jwenn pi bon opsyon pou tout moun, kit se plan yo genyen an oswa Medicare Advantage (Pati C)."
    },
    "partABD": {
      "option": "Pati A, B, ak D (Medicare + Medikaman)",
      "subtext": "N ap jwenn pi bon opsyon pou tout moun."
    },
    "partC": {
      "option": "Pati C (Medicare Advantage)",
      "subtext": "N ap asire nou plan chak moun toujou bon pou yo."
    },
    "payingForDoctor": {
      "option": "Peye pou doktè ak medikaman",
      "subtext": "N ap ede tout moun jwenn asirans ki koute mwens kòb pou doktè ak medikaman."
    },
    "somethingElse": {
      "option": "Yon lòt bagay",
      "subtext": "N ap ede tout moun jwenn asirans epi kenbe li.",
      "subtext_AGING_INTO_MEDICARE": "N ap moutre w etap pa etap ki jan pou w jwenn Medicare.",
      "subtext_AGING_INTO_MEDICARE_awareness": "N ap moutre w etap pa etap ki jan pou w jwenn Medicare.",
      "subtext_RECURRING_WORK_REQUIREMENT": "N ap ede tout moun kenbe asirans yo - san sipriz.",
      "subtext_RECURRING_WORK_REQUIREMENT_awareness": "N ap ede tout moun kenbe asirans yo - san sipriz.",
      "subtext_REDETERMINATION": "Sote papye konplike yo. N ap ede tout moun rete asire.",
      "subtext_REDETERMINATION_awareness": "Sote papye konplike yo. N ap ede tout moun rete asire.",
      "subtext_SERVICE_INTRODUCTION_medicaid": "Sote papye konplike yo. N ap ede tout moun rete asire.",
      "subtext_SERVICE_INTRODUCTION_medicare": "N ap asire nou plan tout moun toujou bon pou yo."
    },
    "submittingRenewals": {
      "option": "Voye renouvèlman yo",
      "subtext": "N ap jere renouvèlman pou tout moun. Se sèlman kèk kesyon senp."
    },
    "tooManyMedicareAdsAndCalls": {
      "option": "Twòp reklam ak kout telefòn Medicare",
      "subtext": "N ap filtre tout bri sa yo epi ede w jwenn bon plan an."
    },
    "variants": {
      "improvedVerbiage": {
        "benefits": {
          "description": "Pointcare ede plis pase 1.8M pasyan jwenn epi kenbe asirans sante yo.",
          "firstItem_LAPSE": "Gade kiyès ki elijib nan 5 minit",
          "infoIsPrivate": "Enfòmasyon w an sekirite avè nou",
          "title": "{{clinicName}} travay ak Pointcare pou ede fanmi w"
        },
        "concerns": {
          "description_LAPSE": "Chwazi sa ki pi enpòtan pou ou, epi n ap moutre w ki jan nou ka ede w.",
          "title_LAPSE": "Kisa ki pi difisil lè w ap chèche asirans pou fanmi w?"
        },
        "intro": {
          "description_LAPSE": "Pifò moun re-elijib pou asirans gratis oswa ki pa koute chè. N ap ede w nan chak etap.",
          "title_LAPSE": "Yon moun nan fanmi w pèdi asirans {{payerName}} li nan dat <colorEmphasis>{{lapseDate}}</colorEmphasis>. Nou la pou nou ede yo jwenn asirans ankò."
        },
        "nextSteps": {
          "step2Description_LAPSE": "Gade pou kisa fanmi w elijib"
        },
        "paperwork": {
          "option": "Papye ki konplike"
        }
      }
    }
  },
  "passwordScreen": {
    "forgotPassword": "Ou bliye modpas ou?",
    "passwordInputLabel": "Modpas",
    "passwordInputPlaceholder": "Antre modpas ou",
    "resetPasswordInstructions": "Nou voye yon lyen pou reyinisyalize modpas la nan <bold>{{email}}</bold>. Louvri li pou kreye yon nouvo modpas.",
    "subtitle": "Tanpri antre modpas kont ou an pou w kontinye.",
    "title": "Antre modpas ou",
    "usernameResetUnavailable": "Kont ak non itilizatè pa ka reyinisyalize modpas pa imèl. Rele nou epi n ap ede ou."
  },
  "profileInformationScreen": {
    "addressComplement": "Apatman, Inite, Bilding (si genyen)",
    "checkCoverage": "Tès Verifikasyon Asirans",
    "coverageStatus": "Estati asirans: {{status}}",
    "dateOfBirth": "Dat nesans",
    "email": "Imèl",
    "firstName": "Prenon",
    "homeAddress": "Adrès kay",
    "lastName": "Non fanmi",
    "mailingAddress": "Adrès postal",
    "mailingAddressComplement": "Apt, Inite, Batiman, Bwat postal (opsyonèl)",
    "medicaidCaseNumber": "Nimewo dosye Medicaid (si ou vle)",
    "medicaidSubscriberId": "Nimewo Medicaid (si ou vle)",
    "noHomeAddress": "Pa gen Adrès Rezidans",
    "noMailingAddress": "Pa gen Adrès pou Resevwa Lèt",
    "phoneNumber": "Nimewo telefòn",
    "socialSecurityNumber": "Nimewo Sekirite Sosyal",
    "useDifferentMailingAddress": "Sèvi ak yon lòt adrès postal"
  },
  "recheckEligibilityScreen": {
    "button": "Verifye eligibilite ankò",
    "title": "Anvan ou verifye ankò, asire w enfòmasyon moun nan fanmi an ajou."
  },
  "redeterminationScreen": {
    "addressInformation": "Mete ajou enfòmasyon sou adrès",
    "alreadyMailedForm": "Mwen voye fòm nan pa lapòs deja oswa mwen pral fè sa talè",
    "caseNumberDescription": "N ap itilize nimewo dosye ou pou soumèt renouvèlman ou pi vit!\n\nChèche l nan fòm renouvèlman ou an oswa nan lòt lèt ki soti nan ajans eta ou konsènan kouvèti ou.",
    "caseNumberDescription_PENDING_FORM": "N ap itilize nimewo dosye ou pou soumèt renouvèlman ou pi vit!\n\nChèche l nan lèt ki soti nan ajans eta ou konsènan kouvèti ou.",
    "caseNumberLabel": "Nimewo Dosye",
    "caseNumberPlaceholder": "Antre nimewo dosye",
    "caseNumberTitle": "Ann ajoute nimewo dosye ou (opsyonèl)",
    "description": "Chwazi pi bon opsyon an",
    "haventReceivedForm": "Mwen poko resevwa fòm nan",
    "receivedForm": "Mwen resevwa fòm nan epi mwen bezwen èd pou m ranpli l",
    "returnToDashboard": "Tounen nan tablodbò",
    "reviewAddress": "Tanpri verifye epi konfime adrès kay ak adrès lapòs pou tout manm fanmi an. Sa asire fòm renouvèlman an rive nan bon adrès la.",
    "successDescription": "Renouvèlman ou an regle. N ap kontakte w si gen yon chanjman.",
    "successDescription_CALL_BACK": "Ekip nou an pral kontakte w nan 1 a 2 jou ouvrab pou fini renouvèlman ou an.",
    "successDescription_PENDING_FORM": "Fòm renouvèlman an ta dwe rive nan adrès ki nan dosye a. Rete veyatif pou lapòs, imèl, ak mesaj tèks. N ap asire nou fè swivi anvan dat limit la.",
    "successTitle": "Ou fin pare nèt!",
    "successTitle_CALL_BACK": "N ap rele w talè.",
    "successTitle_PENDING_FORM": "Ou fin pare nèt!",
    "title": "Renouvèlman kouvèti yon moun nan fanmi w dwe fèt anvan {{date}}."
  },
  "redeterminations": {
    "cardAggregated_CALL_BACK": "{{total}} renouvèlman Medicaid k ap tann yon apèl — yo dwe fèt anvan {{dates}}. Siveye telefòn ou.",
    "cardAggregated_NOT_STARTED": "{{total}} renouvèlman Medicaid pou kòmanse.",
    "cardAggregated_PENDING_FORM": "{{total}} fòm renouvèlman Medicaid ap rive byento. Siveye lapòs, imèl, ak mesaj tèks.",
    "cardCompact_PENDING_FORM": "Fòm renouvèlman ap rive byento — dwe fèt anvan {{date}}",
    "card_CALL_BACK": "Gen yon renouvèlman Medicaid nan fanmi w k ap tann yon apèl — li dwe fèt anvan {{date}}. Siveye telefòn ou.",
    "card_NOT_STARTED": "Gen yon moun nan fanmi w ki gen yon renouvèlman Medicaid ki dwe fèt anvan {{date}}.",
    "card_PENDING_FORM": "Yon moun nan fanmi w pral resevwa yon fòm renouvèlman Medicaid byento — li dwe fèt anvan {{date}}. Siveye lapòs, imèl, ak mesaj tèks.",
    "due": "Dwe fèt anvan {{date}}",
    "medicaidRenewals": "Renouvèlman Medicaid",
    "noRenewals": "Poko gen renouvèlman.",
    "startRenewal": "Kòmanse renouvèlman",
    "status": "Rele m",
    "status_CALL_BACK": "Apèl mande",
    "status_COMPLETED": "Fini",
    "status_NOT_STARTED": "Poko kòmanse",
    "status_PENDING_FORM": "Ap tann fòm",
    "title": "Renouvèlman",
    "updateStatus": "Mete estati ajou"
  },
  "registrationCoverageScreen": {
    "description": "Pointcare ka chèche asirans Medicaid ou kounye a si ou bay enfòmasyon ki anba yo.",
    "title": "Ann tcheke asirans ou"
  },
  "registrationProfileScreen": {
    "description": "Bay enfòmasyon pwofil ou pou nou sèvi ak yo nan aplikasyon yo."
  },
  "resetPasswordScreen": {
    "confirmPasswordInputLabel": "Konfime nouvo modpas la",
    "confirmPasswordInputPlaceholder": "Antre nouvo modpas la ankò",
    "invalidResetLink": "Lyen pou reyinisyalize modpas la pa valab oswa li ekspire. Tanpri mande yon nouvo.",
    "passwordInputLabel": "Nouvo modpas",
    "passwordInputPlaceholder": "Antre nouvo modpas la",
    "subtitle": "Chwazi yon modpas solid ou pa t janm itilize anvan.",
    "title": "Kreye yon nouvo modpas",
    "updatePasswordButton": "Mete modpas ajou"
  },
  "sessionTimedOut": {
    "description": "Pou sekirite w, nou dekonekte w paske ou te rete twò lontan san w pa fè anyen. Konekte ankò.",
    "loginAgain": "Konekte ankò",
    "title": "Yo dekonekte w"
  },
  "sessionTimeout": {
    "countdown": "{{time}} rete",
    "description": "Sesyon ou pral fini talè paske ou pa fè anyen. Èske w vle rete konekte?",
    "logOutNow": "Dekonekte kounye a",
    "secureSession": "Sesyon Sekirize",
    "stayLoggedIn": "Rete konekte",
    "title": "Èske w toujou la?"
  },
  "signatureField": {
    "signaturePrompt": "Trase siyati w"
  },
  "someHouseholdMembersNotUpdated": "Nou pa t kapab sove chanjman pou tout moun. Tanpri tcheke chak moun nan fanmi an.",
  "support": {
    "callUs": "Rele nou",
    "callUsAt": "Rele nou nan <underline>{{phoneNumber}}</underline>"
  },
  "workRequirements": {
    "cardActionCompact_START": "Kòmanse",
    "cardActionCompact_UPLOAD_DOCUMENTS": "Voye",
    "cardAction_CONTINUE": "Kontinye Egzijans Travay",
    "cardAction_START": "Kòmanse Egzijans Travay",
    "cardAction_UPLOAD_DOCUMENTS": "Voye dokiman",
    "cardCompact": "Egzijans Travay Medicaid ki dwe fèt anvan {{date}}",
    "card_CONTINUE": "Gen yon moun nan fanmi w ki gen Egzijans Travay Medicaid ki dwe fèt anvan {{date}}. Fini tcheke kiyès ki an règ oswa ki egzante.",
    "card_START": "Gen yon moun nan fanmi w ki gen Egzijans Travay Medicaid ki dwe fèt anvan {{date}}. Tcheke si w an règ oswa si w egzante.",
    "card_UPLOAD_DOCUMENTS": "Gen yon moun nan fanmi w ki gen Egzijans Travay Medicaid ki dwe fèt anvan {{date}}. Voye dokiman pou w rete an règ.",
    "caseNumbers": {
      "description": "N ap itilize nimewo dosye sa yo pou soumèt dokiman pou fanmi ou.",
      "descriptionSingle": "N ap itilize nimewo dosye sa a pou soumèt dokiman travay {{name}}.",
      "hint": "Chèche yo nan lèt ki soti nan ajans eta ou konsènan kouvèti ou.",
      "hintSingle": "Chèche l nan lèt ki soti nan ajans eta a konsènan kouvèti {{name}}.",
      "memberLabel": "{{name}}",
      "title": "Ann ajoute nimewo dosye fanmi ou (opsyonèl)",
      "titleSingle": "Ann ajoute nimewo dosye {{name}} (opsyonèl)"
    },
    "confirmation": {
      "completedDescription": "Ekip nou an ap revize epi l ap kontakte w si nou bezwen kèk bagay.",
      "completedTitle": "Konpliman, ou fin konplete <label>Egzijans Travay</label> yo",
      "description": "Tanpri pa bliye konplete egzijans ou yo anvan renouvèlman ou ki dwe fèt {{date}}.",
      "title": "<label>Egzijans Travay</label> yo ap fèt",
      "uploadsHint": "Ou ka fini voye dokiman yo nan Akèy la lè lòt mwa yo louvri."
    },
    "due": "Dwe fèt anvan <bold>{{date}}</bold>",
    "exemptions": {
      "description": "Chwazi tout sa ki aplike",
      "groups": {
        "BENEFITS_AND_COVERAGE": "Benefis ak asirans",
        "CAREGIVING": "Okipe yon moun",
        "HEALTH_AND_RECOVERY": "Sante ak retablisman",
        "LIFE_SITUATIONS": "Sitiyasyon lavi"
      },
      "options": {
        "CAREGIVER_OF_CHILD_13_OR_YOUNGER": "Paran oswa moun k ap okipe yon timoun ki gen 13 an oswa mwens",
        "CAREGIVER_OF_PERSON_WITH_DISABILITY": "Moun k ap okipe yon moun ki gen yon andikap",
        "FOSTER_YOUTH_UNDER_26": "Jèn ki nan swen adoptif (foster care) oswa ki te ladan l, ki gen mwens pase 26 an",
        "INCARCERATED_OR_RELEASED_LAST_90_DAYS": "Nan prizon, oswa te soti nan prizon nan 90 dènye jou yo",
        "IN_DRUG_OR_ALCOHOL_TREATMENT": "Nan yon pwogram tretman pou dwòg oswa alkòl",
        "MEDICALLY_FRAIL": "Fèb sou plan medikal",
        "MEETING_SNAP_TANF_WORK_REQUIREMENTS": "Deja respekte egzijans travay SNAP/TANF",
        "NOT_ENROLLED_OR_ELIGIBLE_FOR_MEDICARE": "Pa enskri nan Medicare oswa pa kalifye pou Medicare",
        "PREGNANT_OR_POSTPARTUM": "Ansent oswa fèk akouche (12 mwa oswa mwens)",
        "TRIBAL_MEMBER": "Manm yon tribi Amerendyen ke gouvènman federal la rekonèt",
        "VETERAN_100_PERCENT_DISABILITY": "Ansyen militè ki gen yon nivo andikap total (100%)"
      },
      "title": "Èske nenpòt nan egzanpsyon sa yo aplike?"
    },
    "hours": {
      "communityService": "Sèvis kominotè",
      "description_completed": "Mete kantite èdtan {{name}} fin fè pou {{month}}. Kite l vid si pa gen.",
      "description_expected": "Mete kantite èdtan {{name}} prevwa fè pou {{month}}. Kite l vid si pa gen.",
      "employment": "Travay",
      "employmentHint": "Mete èdtan yo ak salè chak mwa. N ap konvèti salè a an èdtan epi n ap konte sa ki pi wo a pou egzijans lan.",
      "hoursPerMonth": "èdtan / mwa",
      "jobTraining": "Fòmasyon pou travay",
      "payPerMonth": "$ / mwa",
      "school": "Lekòl / apranti",
      "title": "Rapòte èdtan pou {{name}}",
      "totalHours": "Total èdtan",
      "totalOf": "<bold>{{total}}</bold> / {{required}}"
    },
    "income": {
      "description": "Chwazi tout sa ki aplike, oswa kontinye si pa gen pesonn.",
      "everyone": "Tout moun isit la",
      "title": "Kiyès ki touche ${{amount}} oswa plis chak mwa?",
      "titleSingle": "Èske {{name}} touche ${{amount}} oswa plis chak mwa?"
    },
    "medicaidWorkRequirements": "Egzijans Travay Medicaid",
    "nextSteps": {
      "complete": "{{completed}} sou {{total}} fini",
      "description": "Men sa chak moun bezwen voye pou yo kenbe asirans yo.",
      "needsMoreHours": "Bezwen {{hours}} èdtan anplis / mwa",
      "offrampDescription": "Pou kenbe asirans sante, fòk yo fè {{hours}} èdtan aktivite ki apwouve chak mwa. Sa ka gen ladan l travay, fòmasyon pou travay, lekòl, apranti, ak/oswa sèvis kominotè.",
      "opensOn": "Ap louvri {{date}}",
      "proofOfExemption": "Prèv Egzanpsyon",
      "proofOfWork": "Prèv Travay ({{month}})",
      "reasonHours": "Rapòte {{hours}} èdtan / mwa",
      "reasonIncome": "Touche ${{amount}} oswa plis chak mwa",
      "reportedOf": "Rapòte {{hours}} sou {{required}} èdtan / mwa",
      "status_EXEMPT": "Egzante",
      "status_MEETS_REQUIREMENTS": "An règ",
      "title": "Pwochen etap yo pou <label>Egzijans Travay</label>",
      "volunteerOpportunities": "Opòtinite pou fè volontè"
    },
    "noWorkRequirements": "Pa gen egzijans travay pou fanmi w.",
    "progress_ACTION_NEEDED": "Aksyon nesesè",
    "progress_COMPLETED": "Fini",
    "progress_UP_TO_DATE": "Ajou",
    "recheck": "Retcheke Egzijans Travay",
    "sectionTitle": "Egzijans travay",
    "whatAreDescription": "Yon nouvo lwa federal mande sèten granmoun ki gen Medicaid pou yo travay, fè fòmasyon pou yon travay, al lekòl, oswa fè volontè pandan {{hours}} èdtan/mwa. Sa aplike sèlman pou granmoun ki gen ant {{minAge}} ak {{maxAge}} an.",
    "who": {
      "checkAll": "Tcheke tout manm fanmi w",
      "noEligibleMembers": "Pa gen pesonn nan fanmi w ki gen ant {{minAge}} ak {{maxAge}} an, kidonk pa gen pesonn ki bezwen tcheke.",
      "question": "<bold>Kiyès ou vle tcheke? N ap gade si yo an règ oswa si yo egzante, epi n ap ede w apre sa.</bold>",
      "title": "Tcheke Estati Fanmi w pou <label>Egzijans Travay</label>"
    }
  }
}
